import { ReactNode } from 'react';
import { Text } from '@mercator-gcp/grout';
import { PermitChip } from 'components/elements/PermitChip';
import { UseModalResult } from 'hooks/useModal';
import type { PermitChipProps } from 'components/elements/PermitChip';

const labelStyle = {
  whiteSpace: 'nowrap',
};

type Props = {
  Skeleton: UseModalResult<any>['Skeleton'];
  children: ReactNode;
  type: PermitChipProps['type'];
};

export const ModalHeader = ({ Skeleton, children, type }: Props) => (
  <>
    <Text.Lead sx={labelStyle} aria-label="document modal title">
      {type}
    </Text.Lead>
    <Skeleton height="1.25rem" width="8rem">
      {children && <PermitChip type={type}>{children}</PermitChip>}
    </Skeleton>
  </>
);
